import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link, useLocation, useNavigate } from "react-router-dom"
import {
  Button,
  Card,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  PopoverBody,
  Progress,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import moment from "moment"
import action from "../../../assets/icons/action.svg"
import {
  downloadpo,
  fetchPoNewSearch,
  searchPurchaseOrder,
  updatePOStatus,
} from "../../../services/procurement/purchaseOrder"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import PurchaseOrderVoucherFilter from "./filter"
import {
  CancelFinanceVoucherEntry,
  deleteFinanceVoucherEntry,
  fetchFinanceVoucherEntrySearch,
  fetchPOReportSearch,
  updatePOVoucherStatus,
} from "../../../services/finance/finance"
import { capitalize } from "lodash"
import NumberFormat from "../../../utils/numberFormat"

const POReportSearch = ({ fromDashboard, onSelect }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Purchase Orders${companyname ? ` | ${companyname}` : "MEP -Hub"
    }`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const { loggedUser } = useSelector(LoginProperties)

  const [purchaseOrderLi, setPurchaseOrderLi] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [page, setPage] = useState("")
  const [refresh, setRefresh] = useState(0)
  const [country, setCountry] = useState("")
  const [mrno, setMRNo] = useState("")
  const [poNO, setPONO] = useState("")
  const [refId, setRefId] = useState("")
  const [datefrom, setDatefrom] = useState("")
  const [dateto, setDateto] = useState("")
  const [projectName, setProjectName] = useState("")
  const [financial, setFinancial] = useState(true)
  const [confirmModal, setConfirmModal] = useState(false)
  const [confirmType, setConfirmType] = useState("") // "delete" or "cancel"
  const [selectedId, setSelectedId] = useState(null)
  const [dataPerPage, setDataPerPage] = useState(25)
  const navigate = useNavigate()
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const desimalrange = localStorage.getItem("desimalrange") || 2

  const handlePaginate = page => {
    setPage(page)
  }

  useEffect(() => {
    const fetchMaterialRequest = async () => {
      const response = await fetchPOReportSearch({
        params: `${status ? `&status=${status}` : ""}${search ? `&searchText=${search}` : "&searchText"
          }${`&sortOrder=asc`}${page ? `&page=${page}` : ""}${datefrom ? `&from_date=${datefrom}` : ""
          }${dateto ? `&to_date=${dateto}` : ""
          }${`&sizePerPage=16`}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}${refId ? `&ref_id=${refId}` : ""
          }${`&approved_status=2`}`,
      })

      const rawResponse = response?.data?.data // your paginated array

      const updatedData = response?.data?.data.map(item => {
        const grns = Array.isArray(item?.purchaseorder?.grns)
          ? item.purchaseorder.grns
          : []
        const purchase_voucher = Array.isArray(
          item?.purchaseorder?.purchase_voucher
        )
          ? item.purchaseorder.purchase_voucher
          : []

        const combined_vouchers = [...grns, ...purchase_voucher]

        return {
          ...item,
          combined_vouchers,
        }
      })

      const finalOutput = {
        ...response.data,
        data: updatedData,
      }

      console.log(finalOutput, `finalOutput`)

      console.log(response, "response")
      // ${`&financial=${financial}`}
      // setPurchaseOrderLi(response)
      // setPurchaseOrderLi(finalOutput)
      // const newData = response?.data?.data || [];

      setPurchaseOrderLi(prev =>
        page > 1 && prev
          ? {
            ...response.data,
            data: [...(prev.data || []), ...updatedData],
          }
          : {
            ...response.data,
            data: updatedData,
          }
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchMaterialRequest()
  }, [
    refresh,
    status,
    search,
    page,
    mrno,
    poNO,
    datefrom,
    dateto,
    projectName,
    financial,
    fromDashboard,
    refId,
    dataPerPage,
  ])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < purchaseOrderLi?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [purchaseOrderLi, page]);

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleCountryChange = id => {
    setCountry(id)
    setPage(1)
  }

  const handleRequestChange = id => {
    setMRNo(id)
    setPage(1)
  }

  const handlePOChange = id => {
    setPONO(id)
    setPage(1)
  }

  const handleProjectName = id => {
    setProjectName(id)
    setPage(1)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const handleRefChange = id => {
    setRefId(id)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }

  const handleDelete = async id => {
    try {
      const deleteResponse = await deleteFinanceVoucherEntry(id)
      toastSuccess(deleteResponse?.message)
      setRefresh(refresh + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }
  const handleCancel = async id => {
    try {
      const deleteResponse = await CancelFinanceVoucherEntry(id)
      setRefresh(refresh + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const handleApprove = async id => {
    try {
      const updateResponce = await updatePOVoucherStatus({
        params: { id: id, status: confirmType == "approve" ? 2 : 0 },
      })
      toastSuccess(updateResponce?.message)
      setRefresh(refresh + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const handleActivate = id => {
    const updateStatus = async id => {
      try {
        const response = await updatePOStatus(id)
        toastSuccess(response?.message)
      } catch (err) {
        toastError(err?.message)
      }
      setRefresh(refresh + 1)
    }
    updateStatus(id)
  }

  const columns = [
    {
      label: "Refernce No",
      renderCell: item => item?.ref_number,
    },
    {
      label: "Party Name",
      renderCell: item => item?.credit?.name,
    },
    {
      label: <div className="text-end pe-5">Quantity</div>,
      renderCell: item => {
        const totalQty = Array.isArray(item?.purchaseorder?.materials)
          ? item?.purchaseorder?.materials.reduce(
            (sum, mat) => sum + Number(mat.po_quantity || 0),
            0
          )
          : 0

        return (
          <div className="text-end pe-5">
            {NumberFormat(Number(totalQty), desimalrange, desimalrange)}
          </div>
        )
      },
    },
    {
      label: <div className="text-end pe-5">Amount</div>,
      renderCell: item => {
        const totalAmount = Array.isArray(item?.purchaseorder?.materials)
          ? item.purchaseorder.materials.reduce(
            (sum, mat) =>
              sum +
              Number(mat.po_quantity || 0) * Number(mat.unit_price || 0),
            0
          )
          : 0

        return (
          <div className="text-end pe-5">
            {NumberFormat(Number(totalAmount), desimalrange, desimalrange)}
          </div>
        )
      },
    },

    {
      label: (
        <div className={fromDashboard ? "text-end pe-5" : ""}>
          {fromDashboard ? "Amount" : "Created By"}
        </div>
      ),
      renderCell: item => (
        <div className={fromDashboard ? "text-end pe-5" : ""}>
          {fromDashboard
            ? item?.amount
              ? item?.amount
              : 0
            : item?.created_by?.name
              ? capitalize(item?.created_by?.name)
              : "-"}
        </div>
      ),
    },
    {
      label: "Date",
      renderCell: item => moment(item?.date).format("DD-MM-YYYY"),
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <span
            className={`font-13 ${item?.voucher_id == 16 && item?.status == 1
              ? "status-draft"
              : item?.voucher_id == 16 && item?.status == 2
                ? "status-active"
                : item?.voucher_id == 16 && item?.status == 0
                  ? "status-inactive"
                  : item?.custom_status === 1
                    ? "status-active"
                    : "status-inactive"
              }`}
          >
            {item?.status}
          </span>
        </div>
      ),
    },
    // {
    //   label: "Action",
    //   renderCell: item =>
    //     fromDashboard ? (
    //       <Button
    //         color={"primary"}
    //         className={"px-2 py-0 fs-13 btn btn-primary"}
    //         onClick={() => onSelect(item)}
    //       >
    //         Select
    //       </Button>
    //     ) : (
    //       <>
    //         <div>
    //           <span id={`PopoverLegacy-${item?.id}`}>
    //             <img src={action} alt="" className="pointer" />
    //           </span>
    //         </div>
    //         <UncontrolledPopover
    //           placement="bottom"
    //           target={`PopoverLegacy-${item?.id}`}
    //           trigger="legacy"
    //         >
    //           <PopoverBody>
    //             <>
    //               {item?.custom_status !== 0 && item?.status == 1 && (
    //                 <>
    //                   <div
    //                     className="table-popup-content"
    //                     onClick={() =>
    //                       navigate(`/finance-voucher/edit/${item?.id}`)
    //                     }
    //                   >
    //                     Edit
    //                   </div>
    //                   {item?.voucher_id == 16 && item?.status == 1 && (
    //                     <div
    //                       className="table-popup-content"
    //                       onClick={() => {
    //                         setSelectedId(item?.id)
    //                         setConfirmType("approve")
    //                         setConfirmModal(true)
    //                       }}
    //                     >
    //                       Approve
    //                     </div>
    //                   )}
    //                   {item?.voucher_id == 16 && item?.status == 1 && (
    //                     <div
    //                       className="table-popup-content"
    //                       onClick={() => {
    //                         setSelectedId(item?.id)
    //                         setConfirmType("reject")
    //                         setConfirmModal(true)
    //                       }}
    //                     >
    //                       Reject
    //                     </div>
    //                   )}
    //                 </>
    //               )}
    //               {item?.custom_status !== 0 && item?.status != 0 && (
    //                 <div
    //                   className="table-popup-content"
    //                   onClick={() => {
    //                     setSelectedId(item?.id)
    //                     setConfirmType("cancel")
    //                     setConfirmModal(true)
    //                   }}
    //                 >
    //                   Cancel
    //                 </div>
    //               )}
    //               <div
    //                 className="table-popup-content"
    //                 onClick={() => {
    //                   setSelectedId(item?.id)
    //                   setConfirmType("delete")
    //                   setConfirmModal(true)
    //                 }}
    //               >
    //                 Delete
    //               </div>
    //               <div
    //                 className="table-popup-content"
    //                 onClick={() => {
    //                   downloadpo(item?.purchase_order_id, "po.pdf")
    //                 }}
    //               >
    //                 Download
    //               </div>
    //             </>
    //           </PopoverBody>
    //         </UncontrolledPopover>
    //       </>
    //     ),
    // },
  ]

  const subOnGoingColumns = [
    {
      label: "Ref No.",
      renderCell: item => {
        return <div>{item?.code}</div>
      },
    },

    {
      label: <div className="text-end pe-5">Quantity</div>,
      renderCell: item => {
        const totalQty = Array.isArray(item?.materials)
          ? item.materials.reduce(
            (sum, mat) =>
              sum + Number(mat.voucher_quantity || mat.grn_quantity || 0),
            0
          )
          : 0

        return (
          <div className="text-end pe-5">
            {NumberFormat(Number(totalQty), desimalrange, desimalrange)}
          </div>
        )
      },
    },
    {
      label: "Type",
      renderCell: item => {
        const materials = Array.isArray(item?.materials) ? item.materials : []

        const isVoucher = materials.some(mat => mat.voucher_quantity != null) // checks if any has voucher_quantity
        const label = isVoucher ? "Purchase" : "GRN"

        return <div>{label}</div>
      },
    },
    // {
    //   label: "",
    //   renderCell: item => <div></div>,
    // },
    {
      label: "",
      renderCell: item => <></>,
      //   (
      //   <Button color={"primary"} className={"px-2 btn btn-primary"}>
      //     View
      //   </Button>
      // ),
    },
    {
      label: "",
      renderCell: item => <div></div>,
    },
  ]

  return (
    <React.Fragment>
      <div
        className={`${fromDashboard ? "pt-0 dashboard-page-content-view" : "page-content"
          }`}
      >
        <div className="container-fluid">
          {!fromDashboard ? (
            <div className="d-flex justify-content-between">
              <Breadcrumbs
                title="Inventory"
                breadcrumbObject={[
                  { title: "Inventory", link: "/inventory" },
                  { title: crumb || "Reports", link: "/inventory" },
                  {
                    title: "Purchase Order Report",
                    link: "",
                  },
                ]}
              />
              {/* {loggedUser?.permission?.some(
                permissionItem =>
                  permissionItem?.name === "purchaseorder_create"
              ) && (
                <div
                  onClick={() =>
                    navigate(`/finance-voucher/add`, {
                      state: { id: 16, type: "from_po" },
                    })
                  }
                  className={"px-2 mb-3 me-2 btn btn-primary"}
                >
                  {"+ Purchase Order"}
                </div>
              )} */}
            </div>
          ) : (
            <></>
          )}
          <Card className="me-2 px-2 pb-2">
            {!fromDashboard ? (
              <>
                <PurchaseOrderVoucherFilter
                  handleStatusChange={handleStatusChange}
                  handleSearchChange={handleSearchChange}
                  handleCountryChange={handleCountryChange}
                  handleRequestChange={handleRequestChange}
                  handleDateChange={handleDateChange}
                  handleProjectName={handleProjectName}
                  handleFinacialChange={handleFinacialChange}
                  handlePOChange={handlePOChange}
                  handleRefChange={handleRefChange}
                  sampleUrl={"download/suppliers.xlsx"}
                  importUrl={"suppliers/import"}
                  isImport={false}
                />
                <hr className="table-divide" />
              </>
            ) : (
              <></>
            )}
            <Row className="mt-2 ever-rise-table pmr-tbl">
              <Col xs={12}>
              <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                {purchaseOrderLi && (
                  <UpdateTable
                    className="mt-5"
                    nodes={purchaseOrderLi?.data}
                    paginate={purchaseOrderLi}
                    columns={columns}
                    subColumn={subOnGoingColumns}
                    CurrentPage={page}
                    subName={"combined_vouchers"}
                    subHeader={true}
                    handlePagination={handlePaginate}
                    handleSizePerPage={handleSizePerPageChange}
                    tableWidth="10% 20% 10% 10% 20% 10% 20%"
                    mobileWidth="40% 40% 40% 40% 40% 40% 30%"
                    expand={true}
                    isLoading={isLoadingNextPage}
                    hidePaginate={true}
                  />
                )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
        <Modal isOpen={confirmModal} toggle={() => setConfirmModal(false)}>
          <ModalHeader toggle={() => setConfirmModal(false)}>
            {confirmType === "delete"
              ? "Delete Confirmation"
              : confirmType == "cancel"
                ? "Confirmation"
                : confirmType == "approve"
                  ? "Approve Confirmation"
                  : "Reject Confirmation"}
          </ModalHeader>
          <ModalBody>
            Are you sure you want to {confirmType} this entry?
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setConfirmModal(false)}>
              No
            </Button>
            <Button
              color="primary"
              onClick={async () => {
                if (confirmType === "delete") {
                  await handleDelete(selectedId)
                } else if (confirmType === "cancel") {
                  await handleCancel(selectedId)
                } else if (confirmType === "approve") {
                  await handleApprove(selectedId)
                } else if (confirmType === "reject") {
                  await handleApprove(selectedId)
                }
                setConfirmModal(false)
              }}
            >
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default POReportSearch
